export { default } from './StickyHeader';
